export default function checkRole(roles, key) {
  roles = roles || [];
  if (roles.length > 0) {
    if (typeof key === 'string' && roles.indexOf(key) !== -1) {
      return true
    }

    if (Array.isArray(key)) {
      let hasPermission = false

      let i = 0
      for (i = 0; i < key.length; i++) {
        const value = key[i]
        if (roles.indexOf(value) !== -1) {
          hasPermission = true
          break
        }
      }

      return hasPermission
    }
  }

  return false
}



// WEBPACK FOOTER //
// ./src/utils/userRoles.js